export default __webpack_public_path__ + "7262ab5e4e2e3d161f2797705905f4a4.svg";